// extracted by mini-css-extract-plugin
export default {"field":"CardMoveStep_field__HnpJW","text":"CardMoveStep_text__AwHbK","errorMessage":"CardMoveStep_errorMessage__p-0A4"};